import React from 'react'

import {useRouter} from 'next/router'
import {TermsAndConditionsKorean} from '@feature/common/components/terms/termsAndConditions/TermsAndConditionsKorean'
import {TermsAndConditionsEnglish} from '@feature/common/components/terms/termsAndConditions/TermsAndConditionsEnglish'
import {useTranslation} from '@lib/intl/useTranslations'
import Head from 'next/head'
import PageConfig from '@component/layouts/PageConfig/PageConfig'
import useScreenLog from '@hook/useScreenLog'
import TermsNavTabs from '../components/TermsNavTabs'
import {getMessages} from '@lib/intl/intl'

const TermsAndConditionsPage: React.FC = () => {
    const t = useTranslation()
    const {} = useScreenLog({pageName: 'terms_and_condition'})
    const language = useRouter().locale

    return (
        <PageConfig mainClassName={'bg-white dark:bg-bg_dark_background'}>
            <Head>
                <title>{t('termsAndConditions.page.title')}</title>
            </Head>
            <div className={'layout-desktop default_page_padding'}>
                <TermsNavTabs />
                {language == 'ko' ? <TermsAndConditionsKorean /> : <TermsAndConditionsEnglish />}
            </div>
        </PageConfig>
    )
}

export const getStaticProps = async ({locale}) => ({
    props: {
        messages: await getMessages(locale || 'en'),
    },
})

export default TermsAndConditionsPage
